import React from 'react';
import '../../../style/legacy/Conference.css'; // Custom styles
import ConferenceList from './ConferenceList';
import { Link } from 'react-router-dom';
import ConferenceNav from '../../../common/ConferenceNav';
import SEO from '../../../common/SEO';

const ConferenceHome = () => {
  return (
    <>
      <SEO 
        title="Conference Paper Writing Publication & Scientific Conferences Bhopal"
        description="Organize and publish with Assurance Education Group - Conference paper writing publication, IEEE paper writing, SCI paper writing bhopal, and Scopus paper writing."
        keywords={[
          "Conference paper writing publication",
          "Scientific Research",
          "IEEE paper writing",
          "Scopus paper writing bhopal",
          "SCI paper writing bhopal",
          "Research paper writing and publication",
          "Paper Writing Bhopal"
        ]}
        canonicalPath="/conference-home"
      />
      <ConferenceNav />
      <div>
        <div className='hero1'>
          <section className='hero-section'>
            <div className='hero-content'>
              <h1 className='conference-title'>Conferences</h1>
              <p className='conference-subtitle'>
                Providing World Class content and an excellent delegate
                experience Our conferences bring together leading experts from
                academia and industry to discuss the latest research,
                innovations, and trends, fostering collaboration and knowledge
                exchange. Join us for insightful discussions and valuable
                networking opportunities.
              </p>
              <div className='btns'>
                {/* <a href="#register" className="cta-btn1">Find a conference</a> */}
                <Link to='/upcoming-conference'>
                  <button className='cta-btn1 register-button'>
                    Find a conference
                  </button>
                </Link>
              </div>
            </div>
          </section>
          {/* <Notice/> */}
          <ConferenceList isEmbedded={true} />
          {/* <Workshop/> */}

          {/* <Register/> */}
        </div>
      </div>
    </>
  );
};

export default ConferenceHome;
